import { Reducer } from "redux";

import { LATEST_TOS_LOADED, LatestTosLoadedEvent } from "../../events/loaded/latest_tos_loaded";
import { isRoutingEvent } from "../routing_events";
import { ApiTosAcceptance, ApiTosVersion } from "avvir";
import { TOS_ACCEPTANCES_LOADED, TosAcceptancesLoaded } from "../../events/loaded/tos_acceptances_loaded";

export type TosStore = {
  latest: ApiTosVersion,
  acceptances: ApiTosAcceptance[],
};

type Events =
  | LatestTosLoadedEvent
  | TosAcceptancesLoaded

const reduceTos: Reducer<TosStore, Events> = (tos = {
  latest: null,
  acceptances: [],
}, event) => {
  if (isRoutingEvent(event)) {
    return tos;
  }

  switch (event.type) {
    case LATEST_TOS_LOADED: {
      return {
        ...tos,
        latest: event.payload,
      };
    }
    case TOS_ACCEPTANCES_LOADED: {
      return {
        ...tos,
        acceptances: event.payload,
      };
    }
    default: {
      return tos;
    }
  }
};

export default reduceTos;
